import type { ProShiftAvailabilitySlice, TimeBlock } from "@sidegigllc/api/client";
import type React from "react";
import { describeSlice } from "./decompose";

type PROfileAvailabilityProps = {
  slices: ReadonlyArray<ProShiftAvailabilitySlice>;
  timeBlocks?: ReadonlyArray<TimeBlock>;
};

/** Monday-indexed, matching `day_of_week_digit`. Not `daysOfWeek`, which is Sunday-first. */
const DAY_LABELS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"] as const;

export const PROfileAvailability: React.FC<PROfileAvailabilityProps> = ({ slices, timeBlocks = [] }) => {
  if (slices.length === 0) return null;

  const byDay = DAY_LABELS.map((label, digit) => ({
    label,
    entries: slices.filter((slice) => slice.day_of_week_digit === digit),
  })).filter(({ entries }) => entries.length > 0);

  return (
    <>
      <h3 className="my-3 font-semibold @sm/profile:text-large">Availability</h3>
      <dl data-testid="pro_availability">
        {byDay.map(({ label, entries }) => (
          <div key={label} className="my-1 flex gap-2">
            <dt className="w-24 shrink-0 @sm/profile:text-large">{label}</dt>
            <dd data-testid={`pro_availability_${label}`} className="text-gray @sm/profile:text-large">
              {entries.map((slice) => describeSlice(slice, timeBlocks)).join(", ")}
            </dd>
          </div>
        ))}
      </dl>
    </>
  );
};
